import React, { useEffect } from "react";

const ContactUs = () => {
  useEffect(() => {
    document.title = "Contact Us - 10E Beauty";
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-4 py-12 text-[#5c2f2f]">
      <h1 className="text-3xl font-bold mb-6 text-[#a25d5d]">Contact Us</h1>
      <p className="mb-6 text-lg">
        We'd love to hear from you! Fill out the form below or email us directly at{" "}
        <a href="mailto:support@10ebeauty.com" className="text-[#a25d5d] underline hover:text-[#c37676]">
          support@10ebeauty.com
        </a>
      </p>

      <form className="space-y-4">
        <div>
          <label className="block mb-1 font-medium">Full Name</label>
          <input
            type="text"
            className="w-full border border-[#f2cccc] rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#a25d5d]"
            placeholder="Your name"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Email Address</label>
          <input
            type="email"
            className="w-full border border-[#f2cccc] rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#a25d5d]"
            placeholder="you@example.com"
          />
        </div>

        <div>
          <label className="block mb-1 font-medium">Message</label>
          <textarea
            rows={5}
            className="w-full border border-[#f2cccc] rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#a25d5d]"
            placeholder="Your message..."
          />
        </div>

        <button
          type="submit"
          className="bg-[#a25d5d] text-white px-6 py-2 rounded hover:bg-[#944f4f] transition"
        >
          Send Message
        </button>
      </form>
    </div>
  );
};

export default ContactUs;
